/* AirPro PDP — gallery, pack + filter-plan selection, AJAX add to cart, sticky bar, delivery estimate. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = (cents / 100);
    function withDelims(n, decimals, thousands, dec) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(dec);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    return d;
  }

  function initGallery(root) {
    var track = root.querySelector('[data-ap-track]');
    if (!track) return;
    var thumbs = root.querySelectorAll('[data-ap-thumb]');
    var dots = root.querySelectorAll('.ap-gallery__dot');
    function setActive(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.dataset.apThumb;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        setActive(Math.round(track.scrollLeft / track.clientWidth));
        ticking = false;
      });
    }, { passive: true });
  }

  function initMain(root) {
    var dataEl = root.querySelector('[data-ap-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var fmt = function (c) { return formatMoney(c, data.moneyFormat); };

    var form = root.querySelector('[data-ap-form]');
    var idInput = root.querySelector('[data-ap-variant-input]');
    var packInputs = root.querySelectorAll('[data-ap-pack]');
    var planInputs = root.querySelectorAll('[data-ap-plan]');
    var atc = root.querySelector('[data-ap-atc]');
    var atcTotal = root.querySelector('[data-ap-atc-total]');
    var atcLabel = root.querySelector('[data-ap-atc-label]');
    var errorEl = root.querySelector('[data-ap-error]');
    var priceNow = root.querySelector('[data-ap-price-now]');
    var priceWas = root.querySelector('[data-ap-price-was]');
    var priceSave = root.querySelector('[data-ap-price-save]');
    var planPriceEl = root.querySelector('[data-ap-plan-price]');
    var stickyVariant = root.querySelector('[data-ap-sticky-variant]');
    var stickyPrice = root.querySelector('[data-ap-sticky-price]');

    var current = data.variants.find(function (v) { return String(v.id) === idInput.value; }) || data.variants[0];

    var pct = +data.discountPercent || 0;
    var packPriceData = {};
    data.variants.forEach(function (v) { packPriceData[v.id] = v; });

    function planChecked() {
      var checked = root.querySelector('[data-ap-plan]:checked');
      return !!checked && checked.value === '1';
    }
    function planOnFor(v) { return planChecked() && !!v.filterVariant && !!v.sellingPlan; }
    function planOn() { return planOnFor(current); }
    // Purifier price shown with the plan. Display only: the SUBSCRIBE20 automatic discount applies it at checkout.
    function mainPrice(v) { return planOnFor(v) ? Math.round(v.price * (100 - pct) / 100) : v.price; }
    function noDecimals(txt) { return txt.replace(/\.00(?=\D*$)/, ''); }

    function render() {
      idInput.value = current.id;
      var on = planOn();
      var now = mainPrice(current);
      var compare = current.compare > current.price ? current.compare : current.price;
      priceNow.textContent = fmt(now);
      if (priceWas) { priceWas.hidden = !(compare > now); priceWas.textContent = fmt(compare); }
      if (priceSave) { priceSave.hidden = !(compare > now); priceSave.textContent = 'Save ' + noDecimals(fmt(compare - now)); }
      var note = root.querySelector('[data-ap-price-note]');
      if (note) note.hidden = !on;

      // Pack cards follow the selected purchase option
      packInputs.forEach(function (input) {
        var card = input.closest('.ap-pack');
        var v = packPriceData[input.value];
        if (!v) return;
        var p = mainPrice(v);
        var cmp = v.compare > v.price ? v.compare : v.price;
        var qty = +card.dataset.qty || 1;
        var priceEl = card.querySelector('[data-ap-pack-price]');
        var unitEl = card.querySelector('[data-ap-pack-unit]');
        var saveEl = card.querySelector('[data-ap-pack-save]');
        if (priceEl) priceEl.textContent = fmt(p);
        if (unitEl) unitEl.textContent = fmt(Math.round(p / qty));
        if (saveEl) {
          var sp = cmp > p ? Math.floor((cmp - p) * 100 / cmp) : 0;
          saveEl.hidden = sp === 0;
          saveEl.textContent = 'Save ' + sp + '%';
        }
      });

      // Purchase option prices
      var optPlan = root.querySelector('[data-ap-opt-price="plan"]');
      var optPlanCmp = root.querySelector('[data-ap-opt-compare="plan"]');
      var optNone = root.querySelector('[data-ap-opt-price="none"]');
      var planPriceVal = Math.round(current.price * (100 - pct) / 100);
      if (optPlan) optPlan.textContent = fmt(planPriceVal);
      if (optPlanCmp) { optPlanCmp.textContent = fmt(current.price); optPlanCmp.hidden = pct === 0; }
      if (optNone) optNone.textContent = fmt(current.price);
      if (planPriceEl) {
        planPriceEl.textContent = current.filterLaterPrice != null
          ? (data.planPriceTemplate || '').replace('{price}', fmt(current.filterLaterPrice)).replace('{regular}', fmt(current.filterRegular || current.filterLaterPrice))
          : '';
      }

      var total = now + (on && current.filterTodayPrice ? current.filterTodayPrice : 0);
      atcTotal.textContent = fmt(total);
      atc.disabled = !current.available;
      atcLabel.textContent = current.available ? data.atcLabel : 'Sold out';
      if (stickyVariant) stickyVariant.textContent = current.title;
      if (stickyPrice) stickyPrice.textContent = fmt(now);

      packInputs.forEach(function (i) { i.closest('.ap-pack').classList.toggle('is-selected', i.checked); });
      planInputs.forEach(function (i) { i.closest('.ap-plan__opt').classList.toggle('is-selected', i.checked); });
    }

    packInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        current = data.variants.find(function (v) { return String(v.id) === input.value; }) || current;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
        render();
      });
    });
    planInputs.forEach(function (input) { input.addEventListener('change', render); });

    // "Add the filter plan" buttons elsewhere on the page
    document.querySelectorAll('[data-ap-select-plan]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var yes = root.querySelector('[data-ap-plan][value="1"]');
        if (yes) { yes.checked = true; render(); }
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current.available) return;
      errorEl.hidden = true;
      atc.classList.add('is-loading');
      atc.setAttribute('aria-busy', 'true');

      var items = [{ id: current.id, quantity: 1 }];
      if (planOn()) {
        // Same line-item shape as the live page so the SUBSCRIBE20 discount keeps matching.
        items.push({
          id: current.filterVariant,
          quantity: 1,
          selling_plan: current.sellingPlan,
          properties: {
            _recurring_addon_for_product_id: String(data.productId),
            _recurring_addon_for_variant_id: String(current.id)
          }
        });
      }
      var drawer = document.querySelector('cart-drawer');
      var notification = document.querySelector('cart-notification');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      } else if (notification && notification.getSectionsToRender) {
        body.sections = notification.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            throw new Error(res.json.description || res.json.message || 'Could not add to cart');
          }
          var target = drawer || notification;
          if (target && target.renderContents && res.json.sections) {
            if (drawer) drawer.classList.remove('is-empty');
            target.renderContents({ id: current.id, sections: res.json.sections });
          } else {
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
          }
          document.dispatchEvent(new CustomEvent('airpro:added', { detail: { items: items } }));
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        })
        .finally(function () {
          atc.classList.remove('is-loading');
          atc.removeAttribute('aria-busy');
        });
    });

    // Sticky add-to-cart: show once the main button scrolls out of view (and page is past it)
    var sticky = root.querySelector('[data-ap-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelector('[data-ap-sticky-btn]').tabIndex = show ? 0 : -1;
      });
      io.observe(atc);
      sticky.querySelector('[data-ap-sticky-btn]').addEventListener('click', function () {
        root.querySelector('.ap-packs, .ap-form').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // Delivery estimate
    var ship = root.querySelector('[data-ap-ship]');
    if (ship) {
      var min = +ship.dataset.min || 3, max = +ship.dataset.max || 6;
      var o = { weekday: 'short', month: 'short', day: 'numeric' };
      var now = new Date();
      var a = addBusinessDays(now, min).toLocaleDateString(undefined, o);
      var b = addBusinessDays(now, max).toLocaleDateString(undefined, o);
      ship.querySelector('[data-ap-ship-dates]').textContent = a + ' – ' + b;
    }

    render();
  }

  function init() {
    document.querySelectorAll('[data-ap-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-ap-main]').forEach(initMain);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
